import { ChatGrid } from "@mirage/mosaics/Chat/components/layouts/ChatPageLayout";
import { SidePanelContainer } from "@mirage/mosaics/ComposeAssistant/components/side-panel/SidePanelContainer";
import { useWorkflowAgentUI } from "@mirage/mosaics/ComposeAssistant/components/workflow-agent/useWorkflowAgentUI";
import { RoutePath } from "@mirage/webapp/routeTypes";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { useWorkflowAgentAddedSources } from "../hooks/attachments/useManuallyAddedSources";

export const WorkflowAgentPageContent = memo(() => {
  const navigate = useNavigate();
  const { setWorkflowAgentAddedSources, setWorkflowAgentAddedSourcesUUIDs } =
    useWorkflowAgentAddedSources();
  const workflowAgentUI = useWorkflowAgentUI({
    onResetToChat: () => {
      setWorkflowAgentAddedSources([]);
      setWorkflowAgentAddedSourcesUUIDs([]);
      navigate(RoutePath.CHAT, { replace: true });
    },
  });

  if (!workflowAgentUI) {
    return null;
  }

  const chatGrid = (
    <ChatGrid
      logChatEvent={() => {
        // TODO logging
      }}
      sidePane={
        <SidePanelContainer
          leftTitleActions={workflowAgentUI.backButton}
          showWorkflowAgent={workflowAgentUI.showWorkflowAgent}
          rightTitleActions={workflowAgentUI.deleteButton}
        >
          {workflowAgentUI.workflowAgentUI}
        </SidePanelContainer>
      }
    />
  );

  return <>{chatGrid}</>;
});

WorkflowAgentPageContent.displayName = "WorkflowAgentPageContent";
